export default [
  {
    label: 'Common Settings',
    path: 'commonSettings',
    fields: [
      {
        label: 'Enable Conversion',
        type: 'c-switch',
        path: 'payment.configuration.commonSettings.enableConversion',
      },
    ],
  },
  {
    label: 'Accentpay',
    path: 'accentpay',
    enabledPath: 'payment.configuration.accentpay.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.accentpay.currencies' },
      { label: 'Demo', type: 'c-switch', path: 'payment.configuration.accentpay.demo' },
      {
        label: 'Deposit Method',
        type: 'c-multi-select',
        path: 'payment.configuration.accentpay.methods.deposit',
      },
      {
        label: 'Withdraw Method',
        type: 'c-multi-select',
        path: 'payment.configuration.accentpay.methods.withdraw',
      },
      { label: 'Site ID', type: 'c-input', path: 'payment.configuration.accentpay.siteId' },
      { label: 'Salt', type: 'c-input', path: 'payment.configuration.accentpay.salt' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.accentpay.types' },
    ],
  },
  {
    label: 'Api24',
    path: 'api24',
    enabledPath: 'payment.configuration.api24.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.api24.currencies' },
      { label: 'Api Key', type: 'c-input', path: 'payment.configuration.api24.apiKey' },
      { label: 'Api URL', type: 'c-input', path: 'payment.configuration.api24.apiUrl' },
      { label: 'Verify URL', type: 'c-input', path: 'payment.configuration.api24.verifyUrl' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.api24.types' },
    ],
  },
  {
    label: 'Apple Pay',
    path: 'apple_pay',
    enabledPath: 'payment.configuration.apple_pay.enable',
    fields: [
      { label: 'Bundle Id', type: 'c-input', path: 'payment.configuration.apple_pay.bundleId' },
      { label: 'Demo', type: 'c-switch', path: 'payment.configuration.apple_pay.demo' },
    ],
  },
  {
    label: 'Ariapay',
    path: 'ariapay',
    enabledPath: 'payment.configuration.ariapay.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.ariapay.currencies' },
      { label: 'Pin', type: 'c-input', path: 'payment.configuration.ariapay.pin' },
      { label: 'Api URL', type: 'c-input', path: 'payment.configuration.ariapay.apiUrl' },
      { label: 'Redirect URL', type: 'c-input', path: 'payment.configuration.ariapay.redirectUrl' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.ariapay.types' },
    ],
  },
  {
    label: 'Bank Transfer',
    path: 'bank-transfer',
    enabledPath: 'payment.configuration.bank_transfer.enable',
    fields: [
      {
        label: 'Deposit Method',
        type: 'c-multi-select',
        path: 'payment.configuration.bank_transfer.methods.deposit',
      },
      {
        label: 'Withdraw Method',
        type: 'c-multi-select',
        path: 'payment.configuration.bank_transfer.methods.withdraw',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.bank_transfer.types' },
      {
        label: 'Custom Withdraw Commission',
        type: 'c-checkbox',
        path: 'payment.configuration.bank_transfer.custom_withdraw_commission',
      },
    ],
  },
  {
    label: 'Bitcoin',
    path: 'bitcoin',
    enabledPath: 'payment.configuration.bitcoin.enable',
    fields: [
      { label: 'Demo', type: 'c-switch', path: 'payment.configuration.bitcoin.demo' },
      { label: 'Key', type: 'c-input', path: 'payment.configuration.bitcoin.key' },
      { label: 'Timezone', type: 'c-input', path: 'payment.configuration.bitcoin.timezone' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.bitcoin.types' },
    ],
  },
  {
    label: 'Blocktrail',
    path: 'blocktrail',
    enabledPath: 'payment.configuration.blocktrail.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.blocktrail.currencies' },
      { label: 'Demo', type: 'c-switch', path: 'payment.configuration.blocktrail.demo' },
      { label: 'Secret', type: 'c-input', path: 'payment.configuration.blocktrail.secret' },
      { label: 'Key', type: 'c-input', path: 'payment.configuration.blocktrail.key' },
      { label: 'Passhrase', type: 'c-input', path: 'payment.configuration.blocktrail.passhrase' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.blocktrail.types' },
      {
        label: 'Manual Withdraw',
        type: 'c-checkbox',
        path: 'payment.configuration.blocktrail.manual.withdraw',
      },
    ],
  },
  {
    label: 'Casino',
    path: 'casino',
    enabledPath: 'payment.configuration.casino.enable',
    fields: [{ label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.casino.types' }],
  },
  {
    label: 'Coinbase',
    path: 'coinbase',
    enabledPath: 'payment.configuration.coinbase.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.coinbase.currencies' },
      { label: 'Api key', type: 'c-input', path: 'payment.configuration.coinbase.apiKey' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.coinbase.types' },
    ],
  },
  {
    label: 'Coingate',
    path: 'coingate',
    enabledPath: 'payment.configuration.coingate.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.coingate.currencies' },
      { label: 'Demo', type: 'c-switch', path: 'payment.configuration.coingate.demo' },
      { label: 'Description', type: 'c-input', path: 'payment.configuration.coingate.description' },
      {
        label: 'Receive Currency',
        type: 'c-select',
        path: 'payment.configuration.coingate.receiveCurrency',
      },
      { label: 'Title', type: 'c-input', path: 'payment.configuration.coingate.title' },
      { label: 'Token', type: 'c-input', path: 'payment.configuration.coingate.token' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.coingate.types' },
    ],
  },
  {
    label: 'Cubits',
    path: 'cubits',
    enabledPath: 'payment.configuration.cubits.enable',
    fields: [
      {
        label: 'Channel Description',
        type: 'c-input',
        path: 'payment.configuration.cubits.channelDescription',
      },
      { label: 'Channel Name', type: 'c-input', path: 'payment.configuration.cubits.channelName' },
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.cubits.currencies' },
      { label: 'Key', type: 'c-input', path: 'payment.configuration.cubits.key' },
      { label: 'Secret', type: 'c-input', path: 'payment.configuration.cubits.secret' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.cubits.types' },
    ],
  },
  {
    label: 'Easebuzz',
    path: 'easebuzz',
    enabledPath: 'payment.configuration.easebuzz.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.easebuzz.currencies' },
      { label: 'Demo', type: 'c-switch', path: 'payment.configuration.easebuzz.demo' },
      { label: 'Domain', type: 'c-input', path: 'payment.configuration.easebuzz.domain' },
      { label: 'Merchant key', type: 'c-input', path: 'payment.configuration.easebuzz.merchantKey' },
      { label: 'Salt', type: 'c-input', path: 'payment.configuration.easebuzz.salt' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.easebuzz.types' },
    ],
  },
  {
    label: 'Omniware',
    path: 'omniware',
    enabledPath: 'payment.configuration.omniware.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.omniware.currencies' },
      { label: 'Salt', type: 'c-input', path: 'payment.configuration.omniware.salt' },
      { label: 'Domain', type: 'c-input', path: 'payment.configuration.omniware.domain' },
      { label: 'Api Key', type: 'c-input', path: 'payment.configuration.omniware.api_key' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.omniware.types' },
      { label: 'Demo', type: 'c-switch', path: 'payment.configuration.omniware.demo' },
    ],
  },
  {
    label: 'Paed',
    path: 'paed',
    enabledPath: 'payment.configuration.paed.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.paed.currencies' },
      { label: 'Mid', type: 'c-input', path: 'payment.configuration.paed.mid' },
      { label: 'Api Key', type: 'c-input', path: 'payment.configuration.paed.apiKey' },
      { label: 'Password', type: 'c-input', path: 'payment.configuration.paed.password' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paed.types' },
    ],
  },
  {
    label: 'UpiGateway',
    path: 'upigateway',
    enabledPath: 'payment.configuration.upigateway.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.upigateway.currencies' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.upigateway.types' },
    ],
  },
  {
    label: 'Floxy',
    path: 'floxy',
    enabledPath: 'payment.configuration.floxy.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.floxy.currencies' },
      { label: 'Secret', type: 'c-input', path: 'payment.configuration.floxy.secret' },
      { label: 'Api Key', type: 'c-input', path: 'payment.configuration.floxy.api_key' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.floxy.types' },
    ],
  },
  {
    label: 'Epaygate',
    path: 'epaygate',
    enabledPath: 'payment.configuration.epaygate.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.epaygate.currencies' },
      { label: 'Secret', type: 'c-input', path: 'payment.configuration.epaygate.secret' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.epaygate.types' },
    ],
  },
  {
    label: 'Kwidpay',
    path: 'kwidpay',
    enabledPath: 'payment.configuration.kwidpay.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.kwidpay.currencies' },
      { label: 'Token', type: 'c-input', path: 'payment.configuration.kwidpay.token' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.kwidpay.types' },
    ],
  },
  {
    label: 'PaySix',
    path: 'paysix',
    enabledPath: 'payment.configuration.paysix.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.paysix.currencies' },
      { label: 'Salt', type: 'c-input', path: 'payment.configuration.paysix.salt' },
      { label: 'Domain', type: 'c-input', path: 'payment.configuration.paysix.domain' },
      { label: 'Api Key', type: 'c-input', path: 'payment.configuration.paysix.api_key' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paysix.types' },
      { label: 'Demo', type: 'c-switch', path: 'payment.configuration.paysix.demo' },
      { label: 'Public Key', type: 'c-textarea', path: 'payment.configuration.paysix.public_key' },
    ],
  },
  {
    label: 'First Econnect',
    path: 'first-econnect',
    enabledPath: 'payment.configuration.first_econnect.enable',
    fields: [
      { label: 'URL', type: 'c-input', path: 'payment.configuration.first_econnect.url' },
      { label: 'Check URL', type: 'c-input', path: 'payment.configuration.first_econnect.checkUrl' },
      { label: 'Merc ID', type: 'c-input', path: 'payment.configuration.first_econnect.mercId' },
      { label: 'Prod', type: 'c-input', path: 'payment.configuration.first_econnect.prod' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.first_econnect.types' },
    ],
  },
  {
    label: 'Floodpay',
    path: 'floodpay',
    enabledPath: 'payment.configuration.floodpay.enable',
    fields: [
      { label: 'Pin', type: 'c-input', path: 'payment.configuration.floodpay.pin' },
      { label: 'Api URL', type: 'c-input', path: 'payment.configuration.floodpay.apiUrl' },
      { label: 'Redirect URL', type: 'c-input', path: 'payment.configuration.floodpay.redirectUrl' },
      { label: 'Verify URL', type: 'c-input', path: 'payment.configuration.floodpay.verifyUrl' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.floodpay.types' },
    ],
  },
  {
    label: 'Fluttermoney',
    path: 'fluttermoney',
    enabledPath: 'payment.configuration.fluttermoney.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.fluttermoney.currencies' },
      { label: 'Api URL', type: 'c-input', path: 'payment.configuration.fluttermoney.apiUrl' },
      { label: 'Secret', type: 'c-input', path: 'payment.configuration.fluttermoney.secretKey' },
      { label: 'Merch Id', type: 'c-input', path: 'payment.configuration.fluttermoney.merchId' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.fluttermoney.types' },
    ],
  },
  {
    label: 'Google Pay',
    path: 'google_pay',
    enabledPath: 'payment.configuration.google_pay.enable',
    fields: [
      { label: 'Credentials', type: 'c-textarea', path: 'payment.configuration.google_pay.credentials' },
    ],
  },
  {
    label: 'Idpay',
    path: 'idpay',
    enabledPath: 'payment.configuration.idpay.enable',
    fields: [
      { label: 'URL', type: 'c-input', path: 'payment.configuration.idpay.url' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.idpay.types' },
    ],
  },
  {
    label: 'Interswitch',
    path: 'interswitch',
    enabledPath: 'payment.configuration.interswitch.enable',
    fields: [
      { label: 'Product ID', type: 'c-input', path: 'payment.configuration.interswitch.productId' },
      { label: 'Pay Item ID', type: 'c-input', path: 'payment.configuration.interswitch.payItemId' },
      { label: 'Mackey', type: 'c-input', path: 'payment.configuration.interswitch.mackey' },
      { label: 'Merchant Name', type: 'c-input', path: 'payment.configuration.interswitch.merchantName' },
      { label: 'Post Url', type: 'c-input', path: 'payment.configuration.interswitch.postUrl' },
      { label: 'Query Url', type: 'c-input', path: 'payment.configuration.interswitch.queryUrl' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.interswitch.types' },
    ],
  },
  {
    label: 'Mastercard',
    path: 'mastercard',
    enabledPath: 'payment.configuration.mastercard.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.mastercard.currencies' },
      { label: 'Merchant Key', type: 'c-input', path: 'payment.configuration.mastercard.merchantKey' },
      { label: 'Merchant Name', type: 'c-input', path: 'payment.configuration.mastercard.merchantName' },
      {
        label: 'Merchant Address',
        type: 'c-input',
        path: 'payment.configuration.mastercard.merchantAddress',
      },
      {
        label: 'Order Description',
        type: 'c-input',
        path: 'payment.configuration.mastercard.orderDescription',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.mastercard.types' },
    ],
  },
  {
    label: 'Monetbil',
    path: 'monetbil',
    enabledPath: 'payment.configuration.monetbil.enable',
    fields: [
      { label: 'Logo', type: 'c-input', path: 'payment.configuration.monetbil.logo' },
      { label: 'Service Key', type: 'c-input', path: 'payment.configuration.monetbil.serviceKey' },
      { label: 'Service Secret', type: 'c-input', path: 'payment.configuration.monetbil.serviceSecret' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.money_matrix.types' },
    ],
  },
  {
    label: 'Money Matrix',
    path: 'money_matrix',
    enabledPath: 'payment.configuration.money_matrix.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.money_matrix.currencies' },
      { label: 'Demo', type: 'c-switch', path: 'payment.configuration.money_matrix.demo' },
      { label: 'Merchant ID', type: 'c-input', path: 'payment.configuration.money_matrix.merchantId' },
      { label: 'Merchant Key', type: 'c-input', path: 'payment.configuration.money_matrix.merchantKey' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.money_matrix.types' },
    ],
  },
  {
    label: 'Neteller',
    path: 'neteller',
    enabledPath: 'payment.configuration.neteller.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.neteller.currencies' },
      { label: 'Demo', type: 'c-switch', path: 'payment.configuration.neteller.demo' },
      { label: 'Client ID', type: 'c-input', path: 'payment.configuration.neteller.clientId' },
      { label: 'Client Secret', type: 'c-input', path: 'payment.configuration.neteller.clientSecret' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.neteller.types' },
    ],
  },
  {
    label: 'Parspay',
    path: 'parspay',
    enabledPath: 'payment.configuration.parspay.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.parspay.currencies' },
      { label: 'Pin', type: 'c-input', path: 'payment.configuration.parspay.pin' },
      { label: 'Create URL', type: 'c-input', path: 'payment.configuration.parspay.createUrl' },
      { label: 'Start Pay URL', type: 'c-input', path: 'payment.configuration.parspay.startPayUrl' },
      { label: 'Verify URL', type: 'c-input', path: 'payment.configuration.parspay.verifyUrl' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.parspay.types' },
    ],
  },
  {
    label: 'Paydirect',
    path: 'paydirect',
    enabledPath: 'payment.configuration.paydirect.enable',
    fields: [{ label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paydirect.types' }],
  },
  {
    label: 'Paysec',
    path: 'paysec',
    enabledPath: 'payment.configuration.paysec.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.paysec.currencies' },
      {
        label: 'Currencies Wallets',
        type: 'payment-paysec-currencies-wallets',
        path: 'payment.configuration.paysec.currenciesWallets',
        payload: {
          currencies: 'payment.configuration.paysec.currencies',
        },
      },
      { label: 'Demo', type: 'c-switch', path: 'payment.configuration.paysec.demo' },
      { label: 'Product Code', type: 'c-input', path: 'payment.configuration.paysec.productCode' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paysec.types' },
    ],
  },
  {
    label: 'Payvision',
    path: 'payvision',
    enabledPath: 'payment.configuration.payvision.enable',
    fields: [
      { label: 'Demo', type: 'c-switch', path: 'payment.configuration.payvision.demo' },
      { label: 'Member ID', type: 'c-input', path: 'payment.configuration.payvision.memberId' },
      { label: 'Member Guid', type: 'c-input', path: 'payment.configuration.payvision.memberGuid' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.payvision.types' },
    ],
  },
  {
    label: 'Praxis',
    path: 'praxis',
    enabledPath: 'payment.configuration.praxis.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.praxis.currencies' },
      { label: 'Demo', type: 'c-switch', path: 'payment.configuration.praxis.demo' },
      { label: 'Frontend', type: 'c-input', path: 'payment.configuration.praxis.frontend' },
      { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.praxis.merchantId' },
      { label: 'Merchant Secret', type: 'c-input', path: 'payment.configuration.praxis.merchantSecret' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.praxis.types' },
    ],
  },
  {
    label: 'Safecharge',
    path: 'safecharge',
    enabledPath: 'payment.configuration.safecharge.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.safecharge.currencies' },
      { label: 'Demo', type: 'c-switch', path: 'payment.configuration.safecharge.demo' },
      { label: 'Merchant Site', type: 'c-input', path: 'payment.configuration.safecharge.merchantSite' },
      { label: 'Merchant Site ID', type: 'c-input', path: 'payment.configuration.safecharge.merchantSiteId' },
      { label: 'Merchant ID', type: 'c-input', path: 'payment.configuration.safecharge.merchantId' },
      { label: 'Secret Key', type: 'c-input', path: 'payment.configuration.safecharge.secretKey' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.safecharge.types' },
    ],
  },
  {
    label: 'Skrill',
    path: 'skrill',
    enabledPath: 'payment.configuration.skrill.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.skrill.currencies' },
      { label: 'Email', type: 'c-input', path: 'payment.configuration.skrill.email' },
      { label: 'Secret', type: 'c-input', path: 'payment.configuration.skrill.secret' },
      { label: 'Password', type: 'c-input', path: 'payment.configuration.skrill.password' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.skrill.types' },
      { label: 'Manual Withdraw', type: 'c-checkbox', path: 'payment.configuration.skrill.manual.withdraw' },
    ],
  },
  {
    label: 'Spark Pay',
    path: 'sparkpay',
    enabledPath: 'payment.configuration.sparkpay.enable',
    fields: [
      { label: 'Key', type: 'c-input', path: 'payment.configuration.sparkpay.key' },
      { label: 'Password', type: 'c-input', path: 'payment.configuration.sparkpay.password' },
      { label: 'Partner Login Id', type: 'c-input', path: 'payment.configuration.sparkpay.partnerLoginId' },
      { label: 'Checkout Url', type: 'c-input', path: 'payment.configuration.sparkpay.checkoutUrl' },
      { label: 'Status Check Url', type: 'c-input', path: 'payment.configuration.sparkpay.statusCheckUrl' },
      { label: 'Withdraw Url', type: 'c-input', path: 'payment.configuration.sparkpay.withdrawUrl' },
      { label: 'Merchant Name', type: 'c-input', path: 'payment.configuration.sparkpay.merchantName' },
      { label: 'Logo', type: 'c-input', path: 'payment.configuration.sparkpay.logo' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.sparkpay.types' },
    ],
  },
  {
    label: 'Sybapal',
    path: 'sybapal',
    enabledPath: 'payment.configuration.sybapal.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.sybapal.currencies' },
      { label: 'Pin', type: 'c-input', path: 'payment.configuration.sybapal.pin' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.sybapal.types' },
    ],
  },
  {
    label: 'Tarjeta',
    path: 'tarjeta',
    enabledPath: 'payment.configuration.tarjeta.enable',
    fields: [
      { label: 'URL', type: 'c-input', path: 'payment.configuration.tarjeta.url' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.tarjeta.types' },
    ],
  },
  {
    label: 'Ultimpay',
    path: 'ultimpay',
    enabledPath: 'payment.configuration.ultimpay.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.ultimpay.currencies' },
    ],
  },
  {
    label: 'Wirecard',
    path: 'wirecard',
    enabledPath: 'payment.configuration.wirecard.enable',
    fields: [
      { label: 'Currencies', type: 'c-multi-select', path: 'payment.configuration.wirecard.currencies' },
      { label: 'Login', type: 'c-input', path: 'payment.configuration.wirecard.login' },
      { label: 'Password', type: 'c-input', path: 'payment.configuration.wirecard.password' },
      { label: 'Business Key', type: 'c-input', path: 'payment.configuration.wirecard.businessKey' },
      { label: 'Business Key 3D', type: 'c-input', path: 'payment.configuration.wirecard.businessKey3d' },
      { label: '3D', type: 'c-switch', path: 'payment.configuration.wirecard.3d' },
      { label: 'Demo', type: 'c-switch', path: 'payment.configuration.wirecard.demo' },
      { label: 'Checkout', type: 'c-switch', path: 'payment.configuration.wirecard.checkout' },
      { label: 'Commission', type: 'c-switch', path: 'payment.configuration.wirecard.commission' },
      { label: 'Toolkit Password', type: 'c-input', path: 'payment.configuration.wirecard.toolkitPassword' },
      { label: 'Customer ID', type: 'c-input', path: 'payment.configuration.wirecard.customerId' },
      { label: 'Secret', type: 'c-input', path: 'payment.configuration.wirecard.secret' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.wirecard.types' },
      {
        label: 'Manual Withdraw',
        type: 'c-checkbox',
        path: 'payment.configuration.wirecard.manual.withdraw',
      },
    ],
  },
  {
    label: 'Rapidteenpatti',
    path: 'rapidteenpatti',
    enabledPath: 'payment.configuration.rapidteenpatti.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.rapidteenpatti.currencies',
      },
      {
        label: 'Types',
        type: 'c-multi-checkbox',
        path: 'payment.configuration.rapidteenpatti.types',
      },
    ],
  },
  {
    label: 'Instant',
    path: 'instant',
    enabledPath: 'payment.configuration.instant.enable',
    fields: [
      { label: 'Url', type: 'c-input', path: 'payment.configuration.instant.url' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.instant.currencies',
      },
      {
        label: 'Types',
        type: 'c-multi-checkbox',
        path: 'payment.configuration.instant.types',
      },
    ],
  },
  {
    label: 'Manual Deposit',
    path: 'manualdeposit',
    enabledPath: 'payment.configuration.manualdeposit.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.manualdeposit.currencies',
      },
      { label: 'Trello Api Key', type: 'c-input', path: 'payment.configuration.manualdeposit.trelloApiKey' },
      {
        label: 'Trello Api Secret',
        type: 'c-input',
        path: 'payment.configuration.manualdeposit.trelloSecret',
      },
      { label: 'Trello List Id', type: 'c-input', path: 'payment.configuration.manualdeposit.listId' },
      {
        label: 'Types',
        type: 'c-multi-checkbox',
        path: 'payment.configuration.manualdeposit.types',
      },
    ],
  },
  {
    label: 'Paygate',
    path: 'paygate',
    enabledPath: 'payment.configuration.paygate.enable',
    fields: [
      { label: 'Mid code', type: 'c-input', path: 'payment.configuration.paygate.mid_code' },
      { label: 'Mid secret', type: 'c-input', path: 'payment.configuration.paygate.mid_secret' },
      { label: 'Domain', type: 'c-input', path: 'payment.configuration.paygate.domain' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.paygate.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paygate.types' },
    ],
  },
  {
    label: 'S2pay',
    path: 's2pay',
    enabledPath: 'payment.configuration.s2pay.enable',
    fields: [
      { label: 'URL', type: 'c-input', path: 'payment.configuration.s2pay.url' },
      { label: 'Mid secret', type: 'c-input', path: 'payment.configuration.s2pay.salt' },
      { label: 'Encription Key', type: 'c-input', path: 'payment.configuration.s2pay.encryptionKey' },
      { label: 'Decryption Key', type: 'c-input', path: 'payment.configuration.s2pay.decryptionKey' },
      { label: 'Api Key', type: 'c-input', path: 'payment.configuration.s2pay.apiKey' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.s2pay.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.s2pay.types' },
    ],
  },
  {
    label: 'Airpay',
    path: 'airpay',
    enabledPath: 'payment.configuration.airpay.enable',
    fields: [
      { label: 'Username', type: 'c-input', path: 'payment.configuration.airpay.username' },
      { label: 'Password', type: 'c-input', path: 'payment.configuration.airpay.password' },
      { label: 'Api Key', type: 'c-input', path: 'payment.configuration.airpay.apiKey' },
      { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.airpay.merchantId' },
      { label: 'Domain', type: 'c-input', path: 'payment.configuration.airpay.domain' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.airpay.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.airpay.types' },
    ],
  },
  {
    label: 'Nexapay',
    path: 'nexapay',
    enabledPath: 'payment.configuration.nexapay.enable',
    fields: [
      { label: 'Pay Id', type: 'c-input', path: 'payment.configuration.nexapay.payId' },
      { label: 'Salt', type: 'c-input', path: 'payment.configuration.nexapay.secretKey' },
      { label: 'Hosted Key', type: 'c-input', path: 'payment.configuration.nexapay.hostedKey' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.nexapay.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.nexapay.types' },
    ],
  },
  {
    label: 'Vaderpay',
    path: 'vaderpay',
    enabledPath: 'payment.configuration.vaderpay.enable',
    fields: [
      { label: 'Merchand Id', type: 'c-input', path: 'payment.configuration.vaderpay.merchantId' },
      { label: 'Api Key', type: 'c-input', path: 'payment.configuration.vaderpay.apiKey' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.vaderpay.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.vaderpay.types' },
    ],
  },
  {
    label: 'Codunit',
    path: 'codunit',
    enabledPath: 'payment.configuration.codunit.enable',
    fields: [
      { label: 'Token', type: 'c-input', path: 'payment.configuration.codunit.token' },
      { label: 'Password', type: 'c-input', path: 'payment.configuration.codunit.password' },
      { label: 'Member ID', type: 'c-input', path: 'payment.configuration.codunit.memberId' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.codunit.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.codunit.types' },
    ],
  },
  {
    label: 'Vaderpay Net Banking',
    path: 'vaderpaybank',
    enabledPath: 'payment.configuration.vaderpaybank.enable',
    fields: [
      { label: 'Merchand Id', type: 'c-input', path: 'payment.configuration.vaderpaybank.merchantId' },
      { label: 'Api Key', type: 'c-input', path: 'payment.configuration.vaderpaybank.apiKey' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.vaderpaybank.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.vaderpaybank.types' },
    ],
  },
  {
    label: 'SmartPay',
    path: 'smartpay',
    enabledPath: 'payment.configuration.smartpay.enable',
    fields: [
      { label: 'Mid Code', type: 'c-input', path: 'payment.configuration.smartpay.midCode' },
      { label: 'Mid Secret', type: 'c-input', path: 'payment.configuration.smartpay.midSecret' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.smartpay.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.smartpay.types' },
    ],
  },
  {
    label: 'Step2Pay',
    path: 'steppay',
    enabledPath: 'payment.configuration.steppay.enable',
    fields: [
      { label: 'User', type: 'c-input', path: 'payment.configuration.steppay.user' },
      { label: 'Password', type: 'c-input', path: 'payment.configuration.steppay.password' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.steppay.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.steppay.types' },
    ],
  },
  {
    label: 'Recopay',
    path: 'reco',
    enabledPath: 'payment.configuration.reco.enable',
    fields: [
      { label: 'Mid', type: 'c-input', path: 'payment.configuration.reco.mid' },
      { label: 'Token', type: 'c-input', path: 'payment.configuration.reco.token' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.reco.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.reco.types' },
    ],
  },
  {
    label: 'Psk',
    path: 'psk',
    enabledPath: 'payment.configuration.psk.enable',
    fields: [
      { label: 'Pid', type: 'c-input', path: 'payment.configuration.psk.pid' },
      { label: 'Key', type: 'c-input', path: 'payment.configuration.psk.key' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.psk.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.psk.types' },
    ],
  },
  {
    label: 'Payu',
    path: 'payu',
    enabledPath: 'payment.configuration.payu.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.payu.currencies',
      },
      { label: 'Salt', type: 'c-input', path: 'payment.configuration.payu.salt' },
      { label: 'Api Key', type: 'c-input', path: 'payment.configuration.payu.api_key' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.payu.types' },
    ],
  },

  {
    label: 'F2pay',
    path: 'f2pay',
    enabledPath: 'payment.configuration.f2pay.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.f2pay.currencies',
      },
      { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.f2pay.merchantId' },
      { label: 'Private Key', type: 'c-input', path: 'payment.configuration.f2pay.privateKey' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.f2pay.types' },
    ],
  },
  {
    label: 'Freepay',
    path: 'freepay',
    enabledPath: 'payment.configuration.freepay.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.freepay.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.freepay.types' },
    ],
  },
  {
    label: 'Einpays',
    path: 'einpays',
    enabledPath: 'payment.configuration.einpays.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.einpays.currencies',
      },
      { label: 'Api Url', type: 'c-input', path: 'payment.configuration.einpays.apiUrl' },
      { label: 'Client ID', type: 'c-input', path: 'payment.configuration.einpays.clientId' },
      { label: 'Private Key', type: 'c-input', path: 'payment.configuration.einpays.privateKey' },
      { label: 'Public Key', type: 'c-input', path: 'payment.configuration.einpays.einpaysPublicKey' },
      { label: 'Payin method', type: 'c-input', path: 'payment.configuration.einpays.payinMethod' },
      { label: 'Payout method', type: 'c-input', path: 'payment.configuration.einpays.payoutMethod' },
      { label: 'Country', type: 'c-input', path: 'payment.configuration.einpays.countryId' },
      { label: 'Currency', type: 'c-input', path: 'payment.configuration.einpays.currencyId' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.einpays.types' },
    ],
  },
  {
    label: 'Vexora',
    path: 'vexora',
    enabledPath: 'payment.configuration.vexora.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.vexora.currencies',
      },
      { label: 'Api Url', type: 'c-input', path: 'payment.configuration.vexora.apiUrl' },
      { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.vexora.merchantId' },
      { label: 'Api Key', type: 'c-input', path: 'payment.configuration.vexora.apiKey' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.vexora.types' },
    ],
  },
  {
    label: 'Payok',
    path: 'payok',
    enabledPath: 'payment.configuration.payok.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.payok.currencies',
      },
      { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.payok.merchantId' },
      { label: 'Private Key', type: 'c-input', path: 'payment.configuration.payok.merchantPrivateKey' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.payok.types' },
    ],
  },
  {
    label: 'Multipay',
    path: 'multipay',
    enabledPath: 'payment.configuration.multipay.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.multipay.currencies',
      },
      { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.multipay.merchantId' },
      { label: 'Api key', type: 'c-input', path: 'payment.configuration.multipay.apiKey' },
      { label: 'Public Key', type: 'c-input', path: 'payment.configuration.multipay.publicKey' },
      { label: 'Private Key', type: 'c-input', path: 'payment.configuration.multipay.privateKey' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.multipay.types' },
    ],
  },

  {
    label: 'Ipay',
    path: 'ipay',
    enabledPath: 'payment.configuration.ipay.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.ipay.currencies',
      },
      { label: 'Key', type: 'c-input', path: 'payment.configuration.ipay.key' },
      { label: 'Secret', type: 'c-input', path: 'payment.configuration.ipay.secret' },
      { label: 'Merchant', type: 'c-input', path: 'payment.configuration.ipay.merchantId' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.ipay.types' },
    ],
  },

  {
    label: 'tpay',
    path: 'tpay',
    enabledPath: 'payment.configuration.tpay.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.tpay.currencies',
      },
      { label: 'Key', type: 'c-input', path: 'payment.configuration.tpay.appKey' },
      { label: 'Secret', type: 'c-input', path: 'payment.configuration.tpay.appSecret' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.tpay.types' },
    ],
  },
  {
    label: 'Lionpay',
    path: 'lionpay',
    enabledPath: 'payment.configuration.lionpay.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.lionpay.currencies',
      },
      { label: 'url', type: 'c-input', path: 'payment.configuration.lionpay.apiUrl' },
      { label: 'app id', type: 'c-input', path: 'payment.configuration.lionpay.appId' },
      { label: 'cust', type: 'c-input', path: 'payment.configuration.lionpay.custId' },
      { label: 'secret', type: 'c-input', path: 'payment.configuration.lionpay.secretKey' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.lionpay.types' },
    ],
  },
  {
    label: 'Betixpay',
    path: 'betixpay',
    enabledPath: 'payment.configuration.betixpay.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.betixpay.currencies',
      },
      { label: 'Api Url', type: 'c-input', path: 'payment.configuration.betixpay.apiUrl' },
      { label: 'Auth no', type: 'c-input', path: 'payment.configuration.betixpay.authNo' },
      { label: 'Public Key', type: 'c-input', path: 'payment.configuration.betixpay.publicKey' },
      { label: 'Secret', type: 'c-input', path: 'payment.configuration.betixpay.secretKey' },
      { label: 'Payin method', type: 'c-input', path: 'payment.configuration.betixpay.payinMethod' },
      { label: 'Payout method', type: 'c-input', path: 'payment.configuration.betixpay.payoutMethod' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.betixpay.types' },
    ],
  },

  {
    label: 'BetixpayPK',
    path: 'betixpaypkr',
    enabledPath: 'payment.configuration.betixpaypkr.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.betixpaypkr.currencies',
      },
      { label: 'Api Url', type: 'c-input', path: 'payment.configuration.betixpaypkr.apiUrl' },
      { label: 'Auth no', type: 'c-input', path: 'payment.configuration.betixpaypkr.authNo' },
      { label: 'Public Key', type: 'c-input', path: 'payment.configuration.betixpaypkr.publicKey' },
      { label: 'Secret', type: 'c-input', path: 'payment.configuration.betixpaypkr.secretKey' },
      { label: 'Payin method', type: 'c-input', path: 'payment.configuration.betixpaypkr.payinMethod' },
      { label: 'Payout method', type: 'c-input', path: 'payment.configuration.betixpaypkr.payoutMethod' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.betixpaypkr.types' },
    ],
  },

  {
    label: 'Pay2play',
    path: 'pay2play',
    enabledPath: 'payment.configuration.pay2play.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.pay2play.currencies',
      },
      { label: 'Api Url', type: 'c-input', path: 'payment.configuration.pay2play.apiUrl' },
      { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.pay2play.merchantId' },
      { label: 'Api Key', type: 'c-input', path: 'payment.configuration.pay2play.apiKey' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.pay2play.types' },
    ],
  },
  {
    label: 'Ninepay',
    path: 'ninepay',
    enabledPath: 'payment.configuration.ninepay.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.ninepay.currencies',
      },
      { label: 'Private Key', type: 'c-input', path: 'payment.configuration.ninepay.secretKey' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.ninepay.types' },
    ],
  },
  {
    label: 'Tecpay',
    path: 'tecpay',
    enabledPath: 'payment.configuration.tecpay.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.tecpay.currencies',
      },
      { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.tecpay.merchantId' },
      { label: 'Private Key', type: 'c-input', path: 'payment.configuration.tecpay.privateKey' },
      { label: 'Public Key', type: 'c-input', path: 'payment.configuration.tecpay.publicKey' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.tecpay.types' },
    ],
  },
  {
    label: 'Asanpaypkr',
    path: 'asanpaypkr',
    enabledPath: 'payment.configuration.asanpaypkr.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.asanpaypkr.currencies',
      },
      { label: 'URL', type: 'c-input', path: 'payment.configuration.asanpaypkr.apiUrl' },
      { label: 'Merc ID', type: 'c-input', path: 'payment.configuration.asanpaypkr.merchantId' },
      { label: 'API Key', type: 'c-input', path: 'payment.configuration.asanpaypkr.apiKey' },
      { label: 'Store name', type: 'c-input', path: 'payment.configuration.asanpaypkr.storeName' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.asanpaypkr.types' },
    ],
  },
  {
    label: 'Paykassma',
    path: 'paykassma',
    enabledPath: 'payment.configuration.paykassma.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.paykassma.currencies',
      },
      { label: 'Private Key', type: 'c-input', path: 'payment.configuration.paykassma.privateKey' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paykassma.types' },
    ],
  },

  {
    label: 'PaykassmaJazz',
    path: 'paykassma_pkr_jazzcash',
    enabledPath: 'payment.configuration.paykassma.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.paykassma.currencies',
      },
      { label: 'Private Key', type: 'c-input', path: 'payment.configuration.paykassma.privateKey' },
      { label: 'webhook Id', type: 'c-input', path: 'payment.configuration.paykassma.webhookId' },
      { label: 'project Id', type: 'c-input', path: 'payment.configuration.paykassma.projectId' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paykassma.types' },
    ],
  },

  {
    label: 'PaykassmaEasy',
    path: 'paykassma_pkr_easypaisa',
    enabledPath: 'payment.configuration.paykassma.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.paykassma.currencies',
      },
      { label: 'Private Key', type: 'c-input', path: 'payment.configuration.paykassma.privateKey' },
      { label: 'webhook Id', type: 'c-input', path: 'payment.configuration.paykassma.webhookId' },
      { label: 'project Id', type: 'c-input', path: 'payment.configuration.paykassma.projectId' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paykassma.types' },
    ],
  },

  {
    label: 'PaykassmaLink',
    path: 'paykassmalink',
    enabledPath: 'payment.configuration.paykassmalink.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.paykassmalink.currencies',
      },
      { label: 'Private Key', type: 'c-input', path: 'payment.configuration.paykassmalink.privateKey' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paykassmalink.types' },
    ],
  },
  {
    label: 'Silkpay',
    path: 'silkpay',
    enabledPath: 'payment.configuration.silkpay.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.silkpay.currencies',
      },
      { label: 'Api Url', type: 'c-input', path: 'payment.configuration.silkpay.apiUrl' },
      { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.silkpay.merchantId' },
      { label: 'Private Key', type: 'c-input', path: 'payment.configuration.silkpay.secretKey' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.silkpay.types' },
    ],
  },
  {
    label: 'Paypulsepoint',
    path: 'paypulsepoint',
    enabledPath: 'payment.configuration.paypulsepoint.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.paypulsepoint.currencies',
      },
      { label: 'Api Url', type: 'c-input', path: 'payment.configuration.paypulsepoint.apiUrl' },
      { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.paypulsepoint.merchantId' },
      { label: 'payin Api Key', type: 'c-input', path: 'payment.configuration.paypulsepoint.payinApiKey' },
      {
        label: 'payin Encryption Key',
        type: 'c-input',
        path: 'payment.configuration.paypulsepoint.payinEncryptionKey',
      },
      { label: 'payout Api Key', type: 'c-input', path: 'payment.configuration.paypulsepoint.payoutApiKey' },
      {
        label: 'payout Encryption Key',
        type: 'c-input',
        path: 'payment.configuration.paypulsepoint.payoutEncryptionKey',
      },
      {
        label: 'Types',
        type: 'c-multi-checkbox',
        path: 'payment.configuration.paypulsepoint.types',
      },
    ],
  },
  {
    label: 'Tatapay',
    path: 'tatapay',
    enabledPath: 'payment.configuration.tatapay.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.tatapay.currencies',
      },
      { label: 'Api Url', type: 'c-input', path: 'payment.configuration.tatapay.apiUrl' },
      { label: 'Merchant Id', type: 'c-input', path: 'payment.configuration.tatapay.merchantId' },
      { label: 'Private Key', type: 'c-input', path: 'payment.configuration.tatapay.secretKey' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.tatapay.types' },
    ],
  },
  {
    label: 'Betatransfer',
    path: 'betatransfer',
    enabledPath: 'payment.configuration.betatransfer.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.betatransfer.currencies',
      },
      { label: 'Api Url', type: 'c-input', path: 'payment.configuration.betatransfer.apiUrl' },
      { label: 'Public Key', type: 'c-input', path: 'payment.configuration.betatransfer.publicKey' },
      { label: 'Secret Key', type: 'c-input', path: 'payment.configuration.betatransfer.secretKey' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.betatransfer.types' },
    ],
  },
  {
    label: 'Finaxis',
    path: 'finaxis',
    enabledPath: 'payment.configuration.finaxis.enable',
    fields: [
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.finaxis.currencies',
      },
      { label: 'Api Url', type: 'c-input', path: 'payment.configuration.finaxis.apiUrl' },
      { label: 'Api Key', type: 'c-input', path: 'payment.configuration.finaxis.apiKey' },
      { label: 'Secret Key', type: 'c-input', path: 'payment.configuration.finaxis.secretKey' },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.finaxis.types' },
    ],
  },
  {
    label: 'Pinwallet',
    path: 'pinwallet',
    enabledPath: 'payment.configuration.pinwallet.enable',
    fields: [
      { label: 'Key', type: 'c-input', path: 'payment.configuration.pinwallet.key' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.pinwallet.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.pinwallet.types' },
    ],
  },
  {
    label: 'OfcPay',
    path: 'ofcpay',
    enabledPath: 'payment.configuration.ofcpay.enable',
    fields: [
      { label: 'Aid', type: 'c-input', path: 'payment.configuration.ofcpay.aid' },
      { label: 'AKey', type: 'c-input', path: 'payment.configuration.ofcpay.akey' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.ofcpay.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.ofcpay.types' },
    ],
  },
  {
    label: 'Paydunia',
    path: 'paydunia',
    enabledPath: 'payment.configuration.paydunia.enable',
    fields: [
      { label: 'Key', type: 'c-input', path: 'payment.configuration.paydunia.key' },
      { label: 'Mid', type: 'c-input', path: 'payment.configuration.paydunia.mid' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.paydunia.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paydunia.types' },
    ],
  },
  {
    label: 'PBrokers',
    path: 'pbrokers',
    enabledPath: 'payment.configuration.pbrokers.enable',
    fields: [
      { label: 'Username', type: 'c-input', path: 'payment.configuration.pbrokers.username' },
      { label: 'Password', type: 'c-input', path: 'payment.configuration.pbrokers.password' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.pbrokers.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.pbrokers.types' },
    ],
  },
  {
    label: 'Tappay',
    path: 'tappay',
    enabledPath: 'payment.configuration.tappay.enable',
    fields: [
      { label: 'Mid', type: 'c-input', path: 'payment.configuration.tappay.mid' },
      { label: 'Request Salt', type: 'c-input', path: 'payment.configuration.tappay.requestSalt' },
      { label: 'Request Enc Key', type: 'c-input', path: 'payment.configuration.tappay.reqEncryptionKey' },
      { label: 'Response Salt', type: 'c-input', path: 'payment.configuration.tappay.responseSalt' },
      { label: 'Response Enc Key', type: 'c-input', path: 'payment.configuration.tappay.resEncryptionKey' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.tappay.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.tappay.types' },
    ],
  },
  {
    label: 'Paywings',
    path: 'paywings',
    enabledPath: 'payment.configuration.paywings.enable',
    fields: [
      { label: 'Api Key', type: 'c-input', path: 'payment.configuration.paywings.api_key' },
      { label: 'Merchand Id', type: 'c-input', path: 'payment.configuration.paywings.merchant_id' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.paywings.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paywings.types' },
    ],
  },
  {
    label: 'drigpay',
    path: 'drigpay',
    enabledPath: 'payment.configuration.drigpay.enable',
    fields: [
      { label: 'Api Key', type: 'c-input', path: 'payment.configuration.drigpay.key' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.drigpay.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.drigpay.types' },
    ],
  },
  {
    label: 'fintech',
    path: 'fintech',
    enabledPath: 'payment.configuration.fintech.enable',
    fields: [
      { label: 'password', type: 'c-input', path: 'payment.configuration.fintech.password' },
      { label: 'email', type: 'c-input', path: 'payment.configuration.fintech.email' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.fintech.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.fintech.types' },
    ],
  },
  {
    label: 'saspay',
    path: 'saspay',
    enabledPath: 'payment.configuration.saspay.enable',
    fields: [
      { label: 'memberid', type: 'c-input', path: 'payment.configuration.saspay.memberid' },
      { label: 'salt', type: 'c-input', path: 'payment.configuration.saspay.salt' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.saspay.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.saspay.types' },
    ],
  },
  {
    label: 'paymore',
    path: 'paymore',
    enabledPath: 'payment.configuration.paymore.enable',
    fields: [
      { label: 'Mid', type: 'c-input', path: 'payment.configuration.paymore.mid' },
      { label: 'Salt', type: 'c-input', path: 'payment.configuration.paymore.salt' },
      { label: 'Secret', type: 'c-input', path: 'payment.configuration.paymore.secret' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.paymore.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.paymore.types' },
    ],
  },
  {
    label: 'sambhav',
    path: 'sambhav',
    enabledPath: 'payment.configuration.sambhav.enable',
    fields: [
      { label: 'Mid', type: 'c-input', path: 'payment.configuration.sambhav.mid' },
      { label: 'Salt', type: 'c-input', path: 'payment.configuration.sambhav.salt' },
      { label: 'Secret', type: 'c-input', path: 'payment.configuration.sambhav.secret' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.sambhav.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.sambhav.types' },
    ],
  },
  {
    label: 'Pay247',
    path: 'pay247',
    enabledPath: 'payment.configuration.pay247.enable',
    fields: [
      { label: 'Pay Id', type: 'c-input', path: 'payment.configuration.pay247.payId' },
      { label: 'Secret Key', type: 'c-input', path: 'payment.configuration.pay247.secretKey' },
      { label: 'Rmn', type: 'c-input', path: 'payment.configuration.pay247.rmn' },
      { label: 'Password', type: 'c-input', path: 'payment.configuration.pay247.password' },
      { label: 'App Secret', type: 'c-input', path: 'payment.configuration.pay247.appSecret' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.pay247.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.pay247.types' },
    ],
  },
  {
    label: 'Payzin',
    path: 'payzin',
    enabledPath: 'payment.configuration.payzin.enable',
    fields: [
      { label: 'appId', type: 'c-input', path: 'payment.configuration.payzin.appId' },
      { label: 'secret', type: 'c-input', path: 'payment.configuration.payzin.secret' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.payzin.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.payzin.types' },
    ],
  },
  {
    label: 'didapay',
    path: 'didapay',
    enabledPath: 'payment.configuration.didapay.enable',
    fields: [
      { label: 'appId', type: 'c-input', path: 'payment.configuration.didapay.merchantNo' },
      { label: 'privatekey', type: 'c-input', path: 'payment.configuration.didapay.privatekey' },
      { label: 'publickey', type: 'c-input', path: 'payment.configuration.didapay.publickey' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.didapay.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.didapay.types' },
    ],
  },
  {
    label: 'cosmos',
    path: 'cosmos',
    enabledPath: 'payment.configuration.cosmos.enable',
    fields: [
      { label: 'secretKeyDep', type: 'c-input', path: 'payment.configuration.cosmos.secretKeyDep' },
      { label: 'clientIdDep', type: 'c-input', path: 'payment.configuration.cosmos.clientIdDep' },
      { label: 'secretKeyWi', type: 'c-input', path: 'payment.configuration.cosmos.secretKeyW' },
      { label: 'clientIdWi', type: 'c-input', path: 'payment.configuration.cosmos.clientIdW' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.cosmos.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.cosmos.types' },
    ],
  },
  {
    label: 'ismartpay',
    path: 'ismartpay',
    enabledPath: 'payment.configuration.ismartpay.enable',
    fields: [
      { label: 'secretKeyDep', type: 'c-input', path: 'payment.configuration.ismartpay.key' },
      { label: 'clientIdDep', type: 'c-input', path: 'payment.configuration.ismartpay.mid' },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.ismartpay.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.ismartpay.types' },
    ],
  },
  {
    label: 'Depopay',
    path: 'depopay',
    enabledPath: 'payment.configuration.depopay.enable',
    fields: [
      { label: 'Deposit Url', type: 'c-input', path: 'payment.configuration.depopay.depositUrl' },
      {
        label: 'Failed Deposit Redirect Url',
        type: 'c-input',
        path: 'payment.configuration.depopay.failedUrl',
      },
      {
        label: 'Success Deposit Redirect Url',
        type: 'c-input',
        path: 'payment.configuration.depopay.successUrl',
      },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.depopay.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.depopay.types' },
    ],
  },
  {
    label: 'Depopay2',
    path: 'depopay2',
    enabledPath: 'payment.configuration.depopay2.enable',
    fields: [
      { label: 'Deposit Url', type: 'c-input', path: 'payment.configuration.depopay2.depositUrl' },
      {
        label: 'Failed Deposit Redirect Url',
        type: 'c-input',
        path: 'payment.configuration.depopay2.failedUrl',
      },
      {
        label: 'Success Deposit Redirect Url',
        type: 'c-input',
        path: 'payment.configuration.depopay2.successUrl',
      },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.depopay2.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.depopay2.types' },
    ],
  },
  {
    label: 'Cryptopay',
    path: 'cryptopay',
    enabledPath: 'payment.configuration.cryptopay.enable',
    fields: [
      { label: 'Deposit Url', type: 'c-input', path: 'payment.configuration.cryptopay.depositUrl' },
      {
        label: 'Failed Deposit Redirect Url',
        type: 'c-input',
        path: 'payment.configuration.cryptopay.failedUrl',
      },
      {
        label: 'Success Deposit Redirect Url',
        type: 'c-input',
        path: 'payment.configuration.cryptopay.successUrl',
      },
      {
        label: 'Currencies',
        type: 'c-multi-select',
        path: 'payment.configuration.cryptopay.currencies',
      },
      { label: 'Types', type: 'c-multi-checkbox', path: 'payment.configuration.cryptopay.types' },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/components/Projects/Form/payments.js